(function () {

let privacy_cont_el;

function handle_privacy_accept () {
  if (privacy_cont_el && privacy_cont_el.parentNode) {
    privacy_cont_el.parentNode.removeChild(privacy_cont_el);
  }
  window.Shopify.customerPrivacy.setTrackingConsent(
    {
      "analytics":    true,
      "marketing":    true,
      "preferences":  true,
      "sale_of_data": false,
    },
    function(){},
  );
}


function handle_privacy_decline () {
  if (privacy_cont_el && privacy_cont_el.parentNode) {
    privacy_cont_el.parentNode.removeChild(privacy_cont_el);
  }
  window.Shopify.customerPrivacy.setTrackingConsent(
    {
      "analytics":    false,
      "marketing":    false,
      "preferences":  false,
      "sale_of_data": false,
    },
    function(){},
  );
}


function privacy_popup (root_el) {
  privacy_cont_el = document.createElement('div');
  privacy_cont_el.className = 'privacy_cont';
  root_el.appendChild(privacy_cont_el);
  
  const privacy_text_el = document.createElement('div');
  privacy_text_el.className = 'privacy_text';
  privacy_text_el.innerHTML = '<h1>Cookie Consent</h1><p>We use <a href="'+window_api_data.root_url+'/privacy-policy/">cookies</a> to improve your experience and show you country specific content.</p>';
  privacy_cont_el.appendChild(privacy_text_el);

  const privacy_buttons_el = document.createElement('div');
  privacy_buttons_el.className = 'privacy_buttons';
  privacy_cont_el.appendChild(privacy_buttons_el);

  const privacy_accept_el = document.createElement('div');
  privacy_accept_el.className = 'privacy_button privacy_accept';
  privacy_accept_el.innerText = 'Accept';
  privacy_accept_el.addEventListener('click', handle_privacy_accept);
  privacy_buttons_el.appendChild(privacy_accept_el);

  const privacy_decline_el = document.createElement('div');
  privacy_decline_el.className = 'privacy_button privacy_decline';
  privacy_decline_el.innerText = 'Decline';
  privacy_decline_el.addEventListener('click', handle_privacy_decline);
  privacy_buttons_el.appendChild(privacy_decline_el);
}


function privacy_main (root_el) {
  window.Shopify.loadFeatures(
    [
       {
         name: 'consent-tracking-api',
         version: '0.1',
       },
    ],
    error => {
      if (error) {
        console.log(error)
      } else {
        current_consent = window.Shopify.customerPrivacy.currentVisitorConsent();
        if (window_api_data.country == 'UK' || window_api_data.country == 'EU') {
          if (  
            (current_consent.analytics == '' && current_consent.marketing == '' && current_consent.preferences == '' && current_consent.sale_of_data == '')
            ||(current_consent.analytics == 'yes' && current_consent.marketing == 'yes' && current_consent.preferences == 'yes' && current_consent.sale_of_data == 'yes')
          ){
            privacy_popup(root_el);
          }
        }
        else if (current_consent.analytics != 'yes' && current_consent.marketing != 'yes' && current_consent.preferences != 'yes' && current_consent.sale_of_data == 'no') {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              "analytics":    true,
              "marketing":    true,
              "preferences":  true,
              "sale_of_data": false,
            },
            function(){},
          );
        }
      } 
    }
  );
}

window.privacy_main = privacy_main;

})()
